unable to read source [project]/frontend/node_modules/src/ui/scanner/camera-selection-ui.ts